export const AUTH_STATE_DEFAULT = {
  ready: false,
  isFacebookAdsEnabled: false,
  isLogin: false,
  isOnboardingCompleted: false,
  onBoardingStep: 0,
  userScreen: 0,
};
